const capitalize = (s: string): string =>
  s ? s.charAt(0).toUpperCase() + s.slice(1) : '';

export const nameFromEmail = (email: string | null | undefined): string => {
  if (!email) return '';
  const local = email.split('@')[0] ?? '';
  return capitalize(local);
};

export interface DisplayNameInput {
  first_name?: string | null;
  last_name?: string | null;
  email?: string | null;
  username?: string | null;
}

export const userDisplayName = (u: DisplayNameInput | null | undefined): string => {
  if (!u) return 'Unknown';
  const first = (u.first_name || '').trim();
  const last = (u.last_name || '').trim();
  const full = `${first} ${last}`.trim();
  if (full) return capitalize(full);
  const fromEmail = nameFromEmail(u.email);
  if (fromEmail) return fromEmail;
  if (u.username) return capitalize(u.username);
  return 'Unknown';
};
